import { getAuthCode } from "./getAuthCode";
export const deleteUrl = async(changeLoggedUrls,url) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/deleteinput", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({auth_code: await getAuthCode(),content: {url:url}}),
      });
      const result = await response.json();
      console.log(result);
      changeLoggedUrls(result.urls);
    } catch (error) {
      console.log(error);
    }
}